import { useState } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { Menu, X, ShieldCheck } from "lucide-react";
import { Logo } from "@/components/Logo";
import { useSettings } from "@/lib/settings";
import { Button } from "@/components/ui/button";

const NAV = [
  { to: "/", label: "Beranda", end: true },
  { to: "https://sultra.bawaslu.go.id", label: "Berita Terkini", external: true },
  { to: "/suara-masyarakat", label: "Suara Masyarakat" },
  { to: "/media-center", label: "Media Center" },
  { to: "/tanya-bawaslu", label: "Tanya Bawaslu" },
  { to: "/edukasi", label: "Edukasi Pemilu" },
];

export function Navbar() {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const settings = useSettings();

  return (
    <header className="sticky top-0 z-50 bg-white/95 backdrop-blur border-b border-slate-200" data-testid="navbar">
      <div className="bg-navy text-white text-[11px] sm:text-xs">
        <div className="container-page flex items-center justify-between h-8">
          <span className="flex items-center gap-2 font-medium">
            <ShieldCheck className="h-3.5 w-3.5 text-brandred" />
            {settings?.topbar_text || "Bawaslu Provinsi Sulawesi Tenggara"}
          </span>
          <span className="hidden sm:inline text-slate-300">Portal Resmi Komunikasi Publik</span>
        </div>
      </div>
      <div className="container-page flex items-center justify-between h-16">
        <Logo />
        <nav className="hidden lg:flex items-center gap-1">
          {NAV.map((n) =>
            n.external ? (
              <a
                key={n.to}
                href={n.to}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="nav-berita-terkini"
                className="px-3 py-2 text-sm font-semibold rounded-md transition-colors text-slate-600 hover:text-navy hover:bg-slate-50"
              >
                {n.label}
              </a>
            ) : (
              <NavLink
                key={n.to}
                to={n.to}
                end={n.end}
                data-testid={`nav-${n.to === "/" ? "beranda" : n.to.slice(1)}`}
                className={({ isActive }) =>
                  `px-3 py-2 text-sm font-semibold rounded-md transition-colors ${
                    isActive ? "text-brandred" : "text-slate-600 hover:text-navy hover:bg-slate-50"
                  }`
                }
              >
                {n.label}
              </NavLink>
            )
          )}
        </nav>
        <div className="flex items-center gap-2">
          <Button
            onClick={() => navigate("/admin/login")}
            data-testid="masuk-admin-btn"
            className="hidden sm:inline-flex bg-brandred hover:bg-brandred-700 text-white font-semibold rounded-full px-5"
          >
            Masuk Admin
          </Button>
          <button
            className="lg:hidden p-2 text-navy"
            onClick={() => setOpen(!open)}
            data-testid="mobile-menu-toggle"
            aria-label="Menu"
          >
            {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
          </button>
        </div>
      </div>
      {open && (
        <div className="lg:hidden border-t border-slate-200 bg-white" data-testid="mobile-menu">
          <div className="container-page py-3 flex flex-col gap-1">
            {NAV.map((n) =>
              n.external ? (
                <a
                  key={n.to}
                  href={n.to}
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={() => setOpen(false)}
                  data-testid="nav-mobile-berita-terkini"
                  className="px-3 py-2.5 text-sm font-semibold rounded-md text-slate-700 hover:bg-slate-50"
                >
                  {n.label}
                </a>
              ) : (
                <NavLink
                  key={n.to}
                  to={n.to}
                  end={n.end}
                  onClick={() => setOpen(false)}
                  className={({ isActive }) =>
                    `px-3 py-2.5 text-sm font-semibold rounded-md ${
                      isActive ? "bg-brandred/10 text-brandred" : "text-slate-700 hover:bg-slate-50"
                    }`
                  }
                >
                  {n.label}
                </NavLink>
              )
            )}
            <Button
              onClick={() => { setOpen(false); navigate("/admin/login"); }}
              className="mt-2 bg-brandred hover:bg-brandred-700 text-white rounded-full"
            >
              Masuk Admin
            </Button>
          </div>
        </div>
      )}
    </header>
  );
}
